<div class="all">

    <div class="menu">
<div class="sidenav-btn">
    <button mat-icon-button class="menu-inside-btn" [class.pin]="this.pinned" (click)="handlePin()" #tooltip="matTooltip" matTooltip="{{ 'TOOLBAR.PIN_TIP' | translate}}" matTooltipPosition="below">
        <mat-icon svgIcon="pin"></mat-icon>
      </button>
    <button mat-icon-button class="menu-inside-btn" (click)="sidenav.toggle()">
      <mat-icon svgIcon="close_menu"></mat-icon>
    </button>

</div>

    <!-- SIDENAV not connected BASIC  -->
    <ng-container *ngIf="!this.connected && this.roleService.isRole('Basic') && !this.roleService.isRole('Admin')"  >
        <mat-nav-list>
            <a mat-list-item class="list-item" routerLink="" (click)="handleClose()">
                <span class="nav-item">
                    <mat-icon>autorenew</mat-icon>
                    <span class="text">{{"TOOLBAR.CONNECTIONS.SELECT" | translate}}</span>
                </span>
            </a>
            <ng-container *ngIf="this.roleService.isRole('Basic')">
                <a mat-list-item class="list-item" (click)="handleReleaseClick()"><!-- routerLink="releaseNotes" (click)="handleClose()">-->
                    <span class="nav-item">
                        <mat-icon>notes</mat-icon>
                        <span class="text">{{"RELEASENOTES.MENU" | translate}}</span>
                    </span>
                </a>
                <ng-container *ngIf="releaseClicked">
                    <div class="submenu release">
                      <div class="submenu-item" id="release" routerLink="releaseNotes" (click)="handleClose()">
                        <label class="submenu-label">{{"RELEASENOTES.GREENLINE" | translate}}</label>
                        <mat-icon class="submenu-icon_temp">chevron_right</mat-icon>
                      </div>
                      <div class="submenu-item" id="release" routerLink="releaseNotesMultiline" (click)="handleClose()">
                        <label class="submenu-label">{{"RELEASENOTES.MULTI" | translate}}</label>
                        <mat-icon class="submenu-icon_temp">chevron_right</mat-icon>
                      </div>
                      <div class="submenu-item" id="release" routerLink="releaseNotesComponents" (click)="handleClose()">
                        <label class="submenu-label">{{"RELEASENOTES.COMP" | translate}}</label>
                        <mat-icon class="submenu-icon_temp">chevron_right</mat-icon>
                      </div>
                    </div>
                </ng-container>
            </ng-container>
        </mat-nav-list>
    
    </ng-container>
    <!-- SIDENAV connected + Admin -->
    <ng-container *ngIf="this.connected || this.roleService.isRole('Admin')">
    
        <mat-nav-list>
            <a mat-list-item class="list-item" routerLink="menu" (click)="handleClose()" [disabled]="!this.connected && !this.roleService.isRole('Admin')">
                <span class="nav-item">
                    <mat-icon>home</mat-icon>
                    <span class="text">{{"TOOLBAR.HOME" | translate}}</span>
                </span>
            </a>
            <a mat-list-item class="list-item" routerLink="" (click)="switchMachine()" [disabled]="!this.connected && !this.roleService.isRole('Admin')">
                <span class="nav-item">
                    <mat-icon>autorenew</mat-icon>
                    <span class="text">{{"TOOLBAR.CONNECTIONS.SWITCH" | translate}}</span>
                </span>
            </a>
            <div (mouseleave)="changeStateMenu(false)">
                <a mat-list-item class="list-item state" (click)="handleClose()" (mouseover)="changeStateMenu(true)" (activated)="this.toggleState" routerLink="machineState" [disabled]="!this.connected && !this.roleService.isRole('Admin')">
                    <span class="nav-item">
                        <mat-icon svgIcon="bagger"></mat-icon>
                        <span class="text">{{"MASCHINESTATE.MENU" | translate}}</span>
                    </span>
                </a>
                <ng-container *ngIf="toggleState">
                    <div class="submenu">
                        <!-- JOYSTICK -->
                      <div class="submenu-item" routerLink="machineState/joystick" (click)="handleClose()">
                        <mat-icon class="submenu-icon" svgIcon="joystick"></mat-icon>
                        <label class="submenu-label">{{"MASCHINESTATE.JOYSTICK.MENU" | translate}}</label>
                        <mat-icon class="submenu-icon_temp">chevron_right</mat-icon>
                      </div>
                      <!-- CURRENT -->
                      <div class="submenu-item" routerLink="machineState/currents-equipment" (click)="handleClose()">
                        <mat-icon class="submenu-icon">bolt</mat-icon>
                        <label class="submenu-label">{{"MASCHINESTATE.CURRENTS.MENU" | translate}}</label>
                        <mat-icon class="submenu-icon_temp">chevron_right</mat-icon>
                      </div>
                      <!-- PRESSURE GREEN-->
                      <ng-container *ngIf="line == 'green' || line == 'crane'">
                        <div class="submenu-item" routerLink="machineState/pressure-equipment" (click)="handleClose()">
                            <mat-icon class="submenu-icon" svgIcon="pressure"></mat-icon>
                            <label class="submenu-label">{{"MASCHINESTATE.PRESSURE.MENU" | translate}}</label>
                            <mat-icon class="submenu-icon_temp">chevron_right</mat-icon>
                        </div>
                      </ng-container>
                      <!-- PRESSURE / POSITION MULTI -->
                      <ng-container *ngIf="line == 'multi'">
                        <div class="submenu-item" routerLink="machineState/pressure-equipment" (click)="handleClose()">
                            <mat-icon class="submenu-icon" svgIcon="pos_pres"></mat-icon>
                            <label class="submenu-label">{{"MASCHINESTATE.PRESSURE.MENUHEADER_MULTI" | translate}}</label>
                            <mat-icon class="submenu-icon_temp">chevron_right</mat-icon>
                        </div>
                      </ng-container>
                      <!-- POSITION GREEN -->
                      <ng-container *ngIf="line == 'green' || line == 'crane'">
                        <div class="submenu-item" routerLink="machineState/position" (click)="handleClose()">
                            <mat-icon class="submenu-icon" svgIcon="boomAngleIcon"></mat-icon>
                            <label class="submenu-label">{{"MASCHINESTATE.POSITION.MENU" | translate}}</label>
                            <mat-icon class="submenu-icon_temp">chevron_right</mat-icon>
                        </div>
                      </ng-container>
                      <!-- GRAPH -->
                      <div class="submenu-item" routerLink="machineState/graph-equipment" (click)="handleClose()">
                        <mat-icon class="submenu-icon">legend_toggle</mat-icon>
                        <label class="submenu-label">{{"MASCHINESTATE.GRAPH.MENU" | translate}}</label>
                        <mat-icon class="submenu-icon_temp">chevron_right</mat-icon>
                      </div>
                      <!-- TIMES -->
                      <div class="submenu-item" routerLink="machineState/operation-times" (click)="handleClose()">
                        <mat-icon class="submenu-icon" svgIcon="MachineHours"></mat-icon>
                        <label class="submenu-label">{{"MASCHINESTATE.TIMES.MENU" | translate}}</label>
                        <mat-icon class="submenu-icon_temp">chevron_right</mat-icon>
                      </div>
                      <!-- DRIVE MULTI -->
                      <ng-container *ngIf="line == 'multi'">
                        <div class="submenu-item" routerLink="machineState/drive" (click)="handleClose()">
                            <mat-icon class="submenu-icon" svgIcon="drive"></mat-icon>
                            <label class="submenu-label">{{"MASCHINESTATE.DRIVE.MENU" | translate}}</label>
                            <mat-icon class="submenu-icon_temp">chevron_right</mat-icon>
                        </div>
                      </ng-container>
                      <!-- CALIBRATION MULTI -->
                      <ng-container *ngIf="line == 'multi'">
                        <div class="submenu-item" routerLink="machineState/calibration" (click)="handleClose()">
                            <mat-icon class="submenu-icon">tune</mat-icon>
                            <label class="submenu-label">{{"MASCHINESTATE.CALIBRATION.MENU" | translate}}</label>
                            <mat-icon class="submenu-icon_temp">chevron_right</mat-icon>
                        </div>
                      </ng-container>
                    </div>
                </ng-container>
            </div>
        
            <a mat-list-item class="list-item" routerLink="dtc" (click)="handleClose()" [disabled]="!this.connected && !this.roleService.isRole('Admin')">
                <span class="nav-item">
                    <mat-icon>troubleshoot</mat-icon>
                    <span class="text">{{"DTC.MENU" | translate}}</span>
                </span>
            </a>
            <a mat-list-item class="list-item" routerLink="canVisualization" (click)="handleClose()" [disabled]="!this.connected && !this.roleService.isRole('Admin')">
                <span class="nav-item">
                    <mat-icon>mediation</mat-icon>
                    <span class="text">{{"BUS.MENU" | translate}}</span>
                </span>
            </a>
            <a mat-list-item class="list-item" routerLink="ioOverview" (click)="handleClose()" [disabled]="!this.connected && !this.roleService.isRole('Admin')">
                <span class="nav-item">
                    <mat-icon>settings_input_composite</mat-icon>
                    <span class="text">{{"IO.MENU" | translate}}</span>
                </span>
            </a>
            <ng-container *ngIf="this.roleService.isRole('Read_Data')">
                <a mat-list-item class="list-item" routerLink="data" (click)="handleClose()" [disabled]="!this.connected && !this.roleService.isRole('Admin')">
                    <span class="nav-item">
                        <mat-icon>settings</mat-icon>
                        <span class="text">{{"EXPERT.MENU" | translate}}</span>
                    </span>
                </a>
            </ng-container>
            <ng-container *ngIf="this.roleService.isRole('MO_Read')">
                <a mat-list-item class="list-item" routerLink="machineOptions" (click)="handleClose()" [disabled]="!this.connected && !this.roleService.isRole('Admin')">
                    <span class="nav-item">
                        <mat-icon>check_box</mat-icon>
                        <span class="text">{{"OPTIONS.MENU" | translate}}</span>
                    </span>
                </a>
            </ng-container>
            <ng-container *ngIf="this.comissionEnabled && this.roleService.isRole('EOL')">
                <a mat-list-item class="list-item" routerLink="comissioning" (click)="handleClose()" [disabled]="!this.connected && !this.roleService.isRole('Admin')">
                    <span class="nav-item">
                        <mat-icon>power</mat-icon>
                        <span class="text">{{"COMISSION.MENU" | translate}}</span>
                    </span>
                </a>
            </ng-container>
            <ng-container *ngIf="this.roleService.isRole('Basic')">
                <a mat-list-item class="list-item" (click)="handleReleaseClick()"><!-- routerLink="releaseNotes" (click)="handleClose()">-->
                    <span class="nav-item">
                        <mat-icon>notes</mat-icon>
                        <span class="text">{{"RELEASENOTES.MENU" | translate}}</span>
                    </span>
                </a>
                <ng-container *ngIf="releaseClicked">
                    <div class="submenu release">
                      <div class="submenu-item" id="release" routerLink="releaseNotes/greenline" (click)="handleClose()">
                        <label class="submenu-label">{{"RELEASENOTES.GREENLINE" | translate}}</label>
                        <mat-icon class="submenu-icon_temp">chevron_right</mat-icon>
                      </div>
                      <div class="submenu-item" id="release" routerLink="releaseNotes/multiline" (click)="handleClose()">
                        <label class="submenu-label">{{"RELEASENOTES.MULTI" | translate}}</label>
                        <mat-icon class="submenu-icon_temp">chevron_right</mat-icon>
                      </div>
                      <div class="submenu-item" id="release" routerLink="releaseNotesComponents" (click)="handleClose()">
                        <label class="submenu-label">{{"RELEASENOTES.COMP" | translate}}</label>
                        <mat-icon class="submenu-icon_temp">chevron_right</mat-icon>
                      </div>
                    </div>
                </ng-container>
            </ng-container>
        </mat-nav-list>
    </ng-container>

    <!-- SIDENAV no permit -->
    <ng-container *ngIf="!this.connected && !this.roleService.isRole('Basic') && !this.roleService.isRole('Admin') && this.roleService.isRole('Sennebogen')">
        <mat-nav-list>
            <a mat-list-item class="list-item" (click)="handleReleaseClick()"><!-- routerLink="releaseNotes" (click)="handleClose()">-->
                <span class="nav-item">
                    <mat-icon>notes</mat-icon>
                    <span class="text">{{"RELEASENOTES.MENU" | translate}}</span>
                </span>
            </a>
            <ng-container *ngIf="releaseClicked">
                <div class="submenu release">
                    <div class="submenu-item" id="release" routerLink="releaseNotes/greenline" (click)="handleClose()">
                        <label class="submenu-label">{{"RELEASENOTES.GREENLINE" | translate}}</label>
                        <mat-icon class="submenu-icon_temp">chevron_right</mat-icon>
                    </div>
                    <div class="submenu-item" id="release" routerLink="releaseNotes/multiline" (click)="handleClose()">
                        <label class="submenu-label">{{"RELEASENOTES.MULTI" | translate}}</label>
                        <mat-icon class="submenu-icon_temp">chevron_right</mat-icon>
                    </div>
                    <div class="submenu-item" id="release" routerLink="releaseNotesComponents" (click)="handleClose()">
                        <label class="submenu-label">{{"RELEASENOTES.COMP" | translate}}</label>
                        <mat-icon class="submenu-icon_temp">chevron_right</mat-icon>
                    </div>
                </div>
            </ng-container>
        </mat-nav-list>
    
    </ng-container>
    
</div>



<div class="general">
    <a class="general-item" href="https://mysennebogen.com/imprint" target="_blank">{{ 'ABOUT.IMPRESSUM' | translate }}</a>
    <a class="general-item" href="https://www.sennebogen.com/datenschutz" target="_blank">{{ 'ABOUT.DATA_PROTEC' | translate }}</a>
</div>

<a class="spacer"></a>

<a class="my-sennebogen" href="https://mysennebogen.com">
    <img src="../../../assets/images/general/drawer_logo.svg" class="logo" alt="MySennebogen Logo" />
</a>

</div>